import { defineMessages } from 'react-intl';

export default defineMessages({
  foooterPublicHeadline: {
    defaultMessage: '© 2016-{yearTo} 2N Telekomunikace a.s. All rights reserved.',
    description: '',
    id: 'footerPublic.copyright',
  },
});
